var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none",
    viewBox: "0 0 18 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18 2.419a7.7 7.7 0 0 1-2.126.583 3.67 3.67 0 0 0 1.623-2.04c-.713.425-1.5.726-2.34.893a3.689 3.689 0 0 0-6.383 2.523c0 .293.025.574.085.842a10.45 10.45 0 0 1-7.606-3.86 3.7 3.7 0 0 0-.505 1.865c0 1.278.658 2.411 1.64 3.067A3.64 3.64 0 0 1 .72 5.838v.04a3.71 3.71 0 0 0 2.957 3.626c-.3.082-.628.122-.968.122-.236 0-.475-.014-.699-.063a3.725 3.725 0 0 0 3.449 2.57 7.4 7.4 0 0 1-4.576 1.574c-.302 0-.593-.013-.883-.05a10.4 10.4 0 0 0 5.661 1.656c6.79 0 10.503-5.626 10.503-10.501q-.001-.243-.014-.477A7.4 7.4 0 0 0 18 2.419"
  })));
};
export { SvgTwitter as ReactComponent };
export default "/_next/static/chunks/svg/twitter-a4e650ba9f1a3b150e65af4d9b9949b9.svg";